import { HumanReviewQueueSection } from "@/features/patient/human-review/components/HumanReviewQueueView";
import { sampleFlaggedRecords, sampleRecentlyReviewed } from "@/data/patient/humanReview.mock";

export function HumanReviewQueuePage() {
  return (
    <HumanReviewQueueSection
      records={sampleFlaggedRecords}
      recentlyReviewed={sampleRecentlyReviewed}
    />
  );
}
